<template>
  <tr>
    <td v-if="!props.isOperationOffice" class="column-space fix-td">{{account.id}}</td>
    <td class="column-space">{{account.last_name + ' ' + account.first_name}}</td>
    <td class="column-space">{{account.no_email ? '' : account.email}}</td>
    <td class="column-space">{{officeableTypeName(account.officeable_type)}}</td>
    <td class="column-space">{{officeableName(account)}}</td>
    <td class="column-space">{{account.department?.name}}</td>
    <td class="column-space">{{roles[account.role_id]}}</td>
    <td class="column-space">{{account.driver_id}}</td>
    <td class="column-space">{{account.telephone_number}}</td>
    <td class="column-space">
      <StatusChangeConfirmModal
        :item="account"
        :updatableStatusButton="changeStatusAuthority"
        :updatingStatus="updatingStatus"
        @submit="emitChangeStatus"
      />
    </td>
    <td class="column-space">{{formatDateTime(new Date(account.updated_at))}}</td>
    <td class="column-space">
      <DisplayFullnameFromUpdatedBy
        :updatedBy="account.updated_by"
      />
    </td>
    <td v-show="props.isAdmin" class="column-space">
      <div class="d-flex">
        <EditLinkIcon :name="'AccountForm'" :id="account.id" />
        <DeleteIcon
          v-if="props.deletable"
          :deleteAction="deleteAction"
          :isDeleteAuthority="props.deletable"
        />
      </div>
    </td>
  </tr>
</template>

<script setup lang="ts">
import Api from "@/services/api/ApiServiceFabrick";
import StatusChangeConfirmModal from "@/components/AccountParts/StatusChangeConfirmModal.vue";
import DeleteIcon from "@/components/Common/DeleteIcon.vue"
import EditLinkIcon from "@/components/Common/EditLinkIcon.vue";
import DisplayFullnameFromUpdatedBy from '@/components/Common/DisplayFullnameFromUpdatedBy.vue';
import { formatDateTime } from "@/services/functions"
import AccountWithUpdater from "@/types/AccountWithUpdater";
import i18n from '@/lang/i18n';
import { useRouter } from 'vue-router'
const router = useRouter()

const props = defineProps<{
  isAdmin: boolean,
  account: AccountWithUpdater,
  changeStatusAuthority: boolean,
  listLoading: boolean,
  updatingStatus: boolean,
  deletable: boolean,
  showFlash: (message: string, type: string, fadeout: boolean) => void
  reload: () => void,
  isOperationOffice: boolean,
}>();
const emits = defineEmits(['changeStatus']);

const officeableTypeNames: {[key:string]: string} = {
  ManagementOffice: i18n.global.t('pages.accounts.managementOffice'),
  SubManagementOffice: i18n.global.t('pages.accounts.subManagementOffice'),
  OperationOffice: i18n.global.t('pages.accounts.operationOffice'),
  InstallationOffice: i18n.global.t('pages.accounts.installationOffice')
}

const roles = {
  1: i18n.global.t('pages.accounts.administrator'),
  2: i18n.global.t('pages.accounts.driver')
};

function officeableTypeName(officeableType: string) {
  const type = officeableType.split('\\')[2];
  return officeableTypeNames[type];
}
function officeableName() {
  const type = props.account.officeable_type.split('\\')[2];
  if (type == 'OperationOffice') {
    return props.account.officeable.operation_office_name;
  }
  return props.account.officeable.company_name;
}

function emitChangeStatus(params: any) {
  emits('changeStatus', params);
}

async function deleteAction() {
  await Api().deleteAccount(props.account).then(() => {
    props.showFlash(i18n.global.t('pages.common.messages.successDelete'), "success", true)
    props.reload();
  }).catch((e) => {
    errorHandleForDelete(e?.response);
  })
}

function errorHandleForDelete (res: any) {
  switch (res.status) {
    case 400:
      props.showFlash(i18n.global.t('pages.accounts.messages.badRequestForDelete'), "error", true)
      props.reload();
      break
    case 403:
      props.showFlash(i18n.global.t('pages.common.messages.forbidden'), "error", true)
      props.reload();
      break
    default:{
      props.showFlash(i18n.global.t('pages.common.messages.failedDelete'), "error", true)
      props.reload();
    }
  }
}
</script>

<style>
</style>
